import { FC } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { Memo } from '@hoc/Memo'
import { useAppSelector } from '@core/store/hooks'
import { toastSelector } from '@core/services/Toast/store/toast.selector'
import { ToastType } from '@/core/services/Toast/types/ToastType'
import { cn } from '@bem-react/classname'

const cnToast = cn('Toast')

export const Toast: FC = Memo(() => {
  const notification = useAppSelector(toastSelector)

  if (!notification) return ''

  switch (notification?.type) {
    case ToastType.error:
      toast.error(notification.message)
      break
    case ToastType.success:
      toast.success(notification.message)
      break
    case ToastType.loading:
      toast.loading(notification.message)
      break
    case ToastType.custom:
      toast.custom(notification.message)
      break

    default:
      toast(notification.message)
      break
  }

  return (
    <>
      {notification && notification.message && notification.type && (
        <Toaster
          position={notification.position ? notification.position : 'top-right'}
          toastOptions={{
            className: cnToast(),
            style: {
              fontSize: 13,
            },
          }}
        />
      )}
    </>
  )
})
